import { render, staticRenderFns } from "./ordersheet.vue?vue&type=template&id=637902f5"
import script from "./ordersheet.vue?vue&type=script&lang=js"
export * from "./ordersheet.vue?vue&type=script&lang=js"
import style0 from "./ordersheet.vue?vue&type=style&index=0&id=637902f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports